import React, { useEffect, useRef, useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';

function SelectProblem({
  rendercommonFormData,
  patActProbList,
  prefProbList,
  callBack,
  hadleProblemText,
  horizontol = false,
}) {
  const [probType, setProbType] = useState(1);
  const [dxArr, setDxArr] = useState(rendercommonFormData || []);
  const ref = useRef(null);
  const styl = horizontol
    ? { display: 'flex', height: '90px' }
    : { display: 'unset' };
  const handleProbData = (type) => {
    setProbType(type);
    setProbSerVal('');
  };
  const [allData, setAllData] = useState([]);
  const [probSerVal, setProbSerVal] = useState('');
  const [showProbDd, setShowProbDd] = useState(true);
  const [selected, setSelected] = useState(true);

  const removeDxFromArr = (dx) => {
    const filterData = dxArr.filter(
      (item) => parseInt(item.id) !== parseInt(dx)
    );

    const obj = dxArr.find((obj) => obj.id === dx);

    setDxArr(filterData);
    hadleProblemText(obj?.dxName, 'remove');
  };

  useEffect(() => {
    const idsArray = dxArr.map((element) => element.id);
    callBack(idsArray.join(','));
  }, [callBack, dxArr]);

  const handleDxArr = (e) => {
    if (e.target.value) {
      let dxId = e.target.value;
      let idText = e.target.options[e.target.selectedIndex].text;
      let myObj = { id: dxId, dxName: idText };
      if (dxArr) {
        if (dxArr && !dxArr.find((p) => p.id === dxId)) {
          setDxArr((ni) => [...ni, myObj]);
          hadleProblemText(idText, 'add');
        } else {
          setUiMessage('war', 'This problem already added.');
        }
      } else {
        setDxArr((ni) => [...ni, myObj]);
        hadleProblemText(idText, 'add');
      }
    }
  };

  useEffect(() => {
    setSelected(true);
    if (probSerVal.length >= 3 && selected) {
      (async () => {
        try {
          const response = await post(
            'api/patient/progressNote/getDiagnosisListForDropdown',
            {
              term: probSerVal,
              activeFlag: 1,
            }
          );
          if (response.status === 200) {
            setShowProbDd(true);
            setAllData(response?.data);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    } else {
      setShowProbDd(false);
      setAllData([]);
    }
  }, [probSerVal, selected]);

  const handelProbSelect = (val, text, is_billed) => {
    setShowProbDd(false);
    setProbSerVal('');
    setSelected(false);
    if (val) {
      let myObj = { id: val, dxName: text, is_billed: is_billed };
      if (dxArr) {
        if (dxArr && !dxArr.find((p) => p.id === val)) {
          setDxArr((ni) => [...ni, myObj]);
          hadleProblemText(text, 'add');
        } else {
          setUiMessage('war', 'This problem already added.');
        }
      } else {
        setDxArr((ni) => [...ni, myObj]);
        hadleProblemText(text, 'add');
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref?.current && !ref?.current.contains(event.target)) {
        setShowProbDd && setShowProbDd(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setShowProbDd, ref]);

  return (
    <div className="gc-add-dx-sectn" style={styl}>
      <div
        className={`${
          horizontol
            ? 'appt-hx-fa-rw width100 clear-top10 clear-left10'
            : 'width100 clear-top10 wclear-left10'
        }`}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        {horizontol ? (
          <span className="pop-up-sb-hdr">Select Problem</span>
        ) : (
          <span className="pop-up-sb-hdr clear-top10">
            Select Problem from the list
          </span>
        )}
        <div>
          <input
            type="radio"
            name="prefdxType"
            className="clear-right10"
            checked={probType === 1}
            onChange={() => handleProbData(1)}
          />
          Patient
          <input
            type="radio"
            name="prefdxType"
            className="clear-right10 clear-left10"
            checked={probType === 2}
            onChange={() => handleProbData(2)}
          />
          Preferred
          <input
            type="radio"
            name="prefdxType"
            className="clear-right10 clear-left10"
            checked={probType === 3}
            onChange={() => handleProbData(3)}
          />
          Master
        </div>
        <div>
          {(probType === 1 && (
            <div className="width100">
              <select className="cpt-dd" value={''} onChange={handleDxArr}>
                <option value=""></option>
                {patActProbList?.map((p, i) => {
                  return (
                    <option key={i} value={p?.id}>
                      {p?.is_billed && '($) '}
                      {p?.orderName}
                    </option>
                  );
                })}
              </select>
            </div>
          )) ||
            (probType === 2 && (
              <div className="width100">
                <select className="cpt-dd" value={''} onChange={handleDxArr}>
                  <option value=""></option>
                  {prefProbList?.map((p, i) => {
                    return (
                      <option key={i} value={p?.id}>
                        {p?.is_billed && '($) '}
                        {p?.dxName}
                      </option>
                    );
                  })}
                </select>
              </div>
            )) ||
            (probType === 3 && (
              <div className="search-dx-sec" style={{ position: 'relative' }}>
                <div>
                  <input
                    type="search"
                    value={probSerVal}
                    onChange={(e) => setProbSerVal(e.target.value)}
                    className="cpt-master-search"
                    style={{ width: '96%', borderRadius: '5px' }}
                  />
                </div>
                {allData.length > 0 && showProbDd && (
                  <div
                    ref={ref}
                    className="proc-list-dd"
                    style={{ left: 'none', width: 'none' }}
                  >
                    {allData &&
                      allData.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #ccc',
                          }}
                          onClick={() =>
                            handelProbSelect(
                              item?.id,
                              item?.name,
                              item?.is_billed
                            )
                          }
                        >
                          {item?.is_billed && '($) '}
                          {item.name}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
      <div className="width100 grid-sec">
        {dxArr.length > 0 && (
          <div className="clear-top10 problem-list-box">
            {dxArr?.map((d, i) => (
              <div key={i} className="added-dx problem-list-chip">
                <span className="problem-list-chip-text">
                  {d?.is_billed && '($) '}
                  {d.dxName}
                </span>
                <span
                  className="red bold"
                  onClick={() => removeDxFromArr(d?.id)}
                >
                  X
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SelectProblem;
